import AdditionalDocumentsCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { additional_documents: needsIcon, need_to_be_printed } =
      props.selectors.getJourneyAdditionalDocumentsFields(state, props.journeyId);

    return {
      needsIcon,
      icon: need_to_be_printed ? 'printer' : 'document',
    };
  })
);

export default enhance(AdditionalDocumentsCell);
